import { AuthRequestedError } from "../types/requestAuthorization.ts";
import { isPlatformRequestError } from "./isPlatformRequestError.ts";

export function isAuthRequestedError(err: unknown): err is AuthRequestedError {
  return isPlatformRequestError(
    err,
    401,
    "RequestAuthorizationRequired",
    "UserInteractionRequired",
  );
}
